/* eslint-disable max-len, react/jsx-one-expression-per-line, react/jsx-indent, react/jsx-closing-tag-location */
import './SampleReceptionInfo.scss';

export default function RecipientAddress() {
  return (
   <div className="line-height-2 text-xs sample-reception-info-print">
      <p>Pyydämme toimittamaan meille näytteet tuotteesta osoitteeseen</p>

      <br />
      <p>
      ALKO OY NÄYTTEET / Barona Avialogis
      <br />
      Turvalaaksonkuja 4, Ovet 29-31
      <br />
      01740 VANTAA
      </p>

      <br />

      <p>
        Näytteet tulee lähettää toimituslausekkeella DDP Alkon keskusvarasto verot maksettuina.
        <br />
        Näytteet voi tuoda Alkon keskusvarastoon työpäivinä klo 8-15 välillä. Kaikki näytteet (myös mahdollinen ulkoasunäyte) tulee toimittaa samassa lähetyksessä.
      </p>

      <p>
        Mikäli näytelähetykseen tarvitaan Alkon sähköpostiosoite, käytättehän osoitetta
        {' '}
        <a href="mailto:sample.delivery@alko.fi">sample.delivery@alko.fi</a>
        .
      </p>

      <p>
        Kiinnittäkää yllä olevat viivakoodit näytteiden taakse. Ainoastaan tällä tunnisteella varustetut näytteet hyväksytään arviointiin.
      </p>

      <p>
        Näytteiden vastaanotto kommunikoidaan kumppaniverkossa näytteen statuksella kolmen työpäivän sisällä näytteen toimituksesta. Jos ette saa vahvistusta, voitte olla yhteydessä laadunvalvontaan osoitteessa
        {' '}
        <a href="mailto:laatupalaute@alko.fi">laatupalaute@alko.fi</a>
        .
      </p>

       <br />
       <br />

        <p>We kindly ask you to provide us with samples of the product to the following address: </p>

        <p>
        <br />
        ALKO OY SAMPLES / Barona Avialogis
        <br />
        Turvalaaksonkuja 4, Ovet 29-31
        <br />
        01740 VANTAA
        </p>

        <br />

        <p>Samples must be sent with the delivery term DDP Alko central warehouse, taxes paid. Samples may be delivered to Alko's central warehouse on working days between 8:00 and 15:00. All samples (including any possible packaging sample) must be delivered in the same shipment.</p>

        <p>
          If an email address is required for the sample shipment, please use:
          {' '}
          <a href="mailto:sample.delivery@alko.fi">sample.delivery@alko.fi</a>
          .
        </p>

        <p>
          Please attach the above barcodes to the back of the samples. Only samples with this information will be accepted for evaluation.</p>
        <p>
          Receipt of the samples will be communicated in the partner network with a sample status update within three working days of delivery. If you do not receive confirmation, you may contact Quality Control at
          {' '}
          <a href="mailto:laatupalaute@alko.fi">laatupalaute@alko.fi</a>
          .
        </p>
    </div>
  );
}
